"use client";

import { useBreakpoint } from "@/app/hooks/useBreakpoint";
import { FlightClassWithTravellers } from "./FlightClassWithTravellers/FlightClassWithTravellers";
import { FlightFields } from "./FlightFields/FlightFields";
import FlightTypeDropdown from "./FlightTypeDropdown";
import { useSearchFlights } from "./useSearchFlights";
import type { EventFlightDetails } from "@/app/types/event";

const SearchFlightsWidget = ({
  flightDetails,
}: {
  flightDetails?: EventFlightDetails;
}) => {
  const breakpoint = useBreakpoint();

  const {
    values,
    handleAddDestination,
    handleRemoveDestination,
    handleChangeFlightType,
    handleClearAll,
    setValues,
    updateFlightField,
    buildFlightSearchPayload,
  } = useSearchFlights(flightDetails);

  const isFullScreenModal = !breakpoint || breakpoint === "sm";

  return (
    <div className="sm:flex justify-center">
      <div
        id="flight-search"
        className="p-4 md:px-8 md:pt-5 md:pb-8 bg-white dark:bg-sleap-gray-950 rounded-2xl"
      >
        <div className="flex flex-col gap-2 mb-2 md:mb-4 sm:flex-row sm:items-center">
          <FlightTypeDropdown
            value={values.flightType}
            onChange={handleChangeFlightType}
          />
          <FlightClassWithTravellers
            values={values}
            className="sm:block hidden"
            setValues={setValues}
            isFullScreenModal={isFullScreenModal}
          />
        </div>
        <FlightFields
          values={values}
          onAddDestination={handleAddDestination}
          onRemoveDestination={handleRemoveDestination}
          onClearAll={handleClearAll}
          updateFlightField={updateFlightField}
          buildFlightSearchPayload={buildFlightSearchPayload}
          setValues={setValues}
          toLocation={flightDetails?.airport || ""}
        />
      </div>
    </div>
  );
};

export default SearchFlightsWidget;
